import { useApp } from '@/hooks/use-app-context';
import { ResetPasswordFormPanel } from '@/features/reset-password/ResetPasswordFormPanel';
import { ResetPasswordShell } from '@/features/reset-password/ResetPasswordLayout';
import { ResetPasswordStatusPanel } from '@/features/reset-password/ResetPasswordStatusPanel';
import { useResetPasswordForm } from '@/features/reset-password/use-reset-password-form';

export default function ResetPassword() {
  const { t } = useApp();
  const reset = useResetPasswordForm({ t });

  return (
    <ResetPasswordShell currentLang={reset.currentLang} t={t} showSecurityNote={reset.viewState === 'form'}>
      {reset.viewState === 'form' ? (
        <ResetPasswordFormPanel
          t={t}
          password={reset.password}
          confirmPassword={reset.confirmPassword}
          showPassword={reset.showPassword}
          showConfirmPassword={reset.showConfirmPassword}
          loading={reset.loading}
          passwordHasMinLength={reset.passwordHasMinLength}
          passwordHasLetterCase={reset.passwordHasLetterCase}
          passwordHasDigitAndSpecial={reset.passwordHasDigitAndSpecial}
          passwordsMatch={reset.passwordsMatch}
          canSubmit={reset.canSubmit}
          onPasswordChange={reset.setPassword}
          onConfirmPasswordChange={reset.setConfirmPassword}
          setShowPassword={reset.setShowPassword}
          setShowConfirmPassword={reset.setShowConfirmPassword}
          onSubmit={reset.handleSubmit}
          onBackToLogin={reset.goToLogin}
        />
      ) : (
        <ResetPasswordStatusPanel
          t={t}
          state={reset.viewState}
          onRequestNewLink={reset.requestNewLink}
          onBackToLogin={reset.goToLogin}
        />
      )}
    </ResetPasswordShell>
  );
}


